/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./CnPrivacy.css";
import { Link } from "react-router-dom";
import { renderHomePageHeader } from "../../assets/component/renderHomePageHeader.js";
import { Helmet } from "react-helmet";
import HomepageMenuCn from "../../assets/component/HomepageMenuCn/HomepageMenuCn.js";

class CnPrivacy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  showModal() {
    this.setState({
      showModal: true,
    });
  }

  closeModal() {
    this.setState({
      showModal: false,
    });
  }
  render() {
    return (
      <div className="CnPrivacy-view">
        <Helmet>
          <title>私隐 - CheckPlus</title>
        </Helmet>
        {!!this.state.showModal && (
          <HomepageMenuCn closeModal={this.closeModal} />
        )}
        {renderHomePageHeader(this)}

        <div className="CnPrivacy-section">
          <div className="CnPrivacy-privacy">
            <div className="CnPrivacy-privacyIcn" />
            <div className="CnPrivacy-privacyTxt">私隐</div>
            <div className="CnPrivacy-privacyDescription">
              你的数据应该是属于你的。
            </div>
            <div className="CnPrivacy-privacyDescription2">
              私隐对我们非常重要。我们相信你的数据应该是属于你的，所以 CheckPlus
              承诺绝不将我们的用户数据在未经您的同意下转售给任何第三方公司。当我们设计
              CheckPlus 时，我们的团队考虑到私隐，因此你可以放心。
            </div>
            <Link to="/CnPrivacyPolicy">
              <div className="CnPrivacy-privacyBtn">
                <div className="CnPrivacy-privacyBtnTxt">
                  查看我们的私隐政策
                </div>
                <div className="CnPrivacy-privacyNext" />
              </div>
            </Link>
          </div>

          <div className="CnPrivacy-aws">
            <div className="CnPrivacy-leftContainer">
              <div className="CnPrivacy-leftGroup">
                <div className="CnPrivacy-storageIcn" />
                <div className="CnPrivacy-heading">安全数据处理</div>
                <div className="CnPrivacy-description">
                  你的数据安全地储存在我们 AWS 的伺服器中。
                </div>
                <div className="CnPrivacy-tickContainer">
                  <div className="CnPrivacy-tickIcn" />
                  <div className="CnPrivacy-tickTxt">HTTPS</div>
                </div>
                <div className="CnPrivacy-tickContainer">
                  <div className="CnPrivacy-tickIcn" />
                  <div className="CnPrivacy-tickTxt">SSL</div>
                </div>
                <div className="CnPrivacy-tickContainer">
                  <div className="CnPrivacy-tickIcn" />
                  <div className="CnPrivacy-tickTxt">ISO27001 Certified</div>
                </div>
              </div>
              <div className="CnPrivacy-blackFilter"></div>
            </div>
            <div className="CnPrivacy-rightContainer">
              <div className="CnPrivacy-awsLogo" />
            </div>
          </div>
          <div className="CnPrivacy-stripe">
            <div className="CnPrivacy-leftContainer">
              <div className="CnPrivacy-leftGroup">
                <div className="CnPrivacy-paymentIcn" />
                <div className="CnPrivacy-heading">安全付款</div>
                <div className="CnPrivacy-description">
                  所有卡号码均使用 AES-256
                  技术加密，全球各大银行和政府也使用相同的加密技术。
                </div>
              </div>
              <div className="CnPrivacy-blackFilter"></div>
            </div>
            <div className="CnPrivacy-rightContainer">
              <div className="CnPrivacy-stripeLogo" />
            </div>
          </div>
          <div className="CnPrivacy-checkplus">
            <div className="CnPrivacy-leftContainer">
              <div className="CnPrivacy-leftGroup">
                <div className="CnPrivacy-commitmentIcn" />
                <div className="CnPrivacy-heading">CheckPlus 的承诺</div>
                <div className="CnPrivacy-description">
                  保护您的私隐是我们的承诺，我们会继续积极寻找更多保护你私隐的方法。
                </div>
              </div>
              <div className="CnPrivacy-blackFilter"></div>
            </div>
            <div className="CnPrivacy-rightContainer">
              <div className="CnPrivacy-checkplusLogo" />
            </div>
          </div>
        </div>

        <div className="CnPrivacy-footer">
          <div className="CnPrivacy-footerNav">
            <Link to="/CnTeam">
              <div className="CnPrivacy-footerNavItem">创办人的故事</div>
            </Link>
            <Link to="/CnFaq">
              <div className="CnPrivacy-footerNavItem">常见问题</div>
            </Link>
            <Link to="/CnContact">
              <div className="CnPrivacy-footerNavItem">联络我们</div>
            </Link>

            <Link to="/CnPrivacyPolicy">
              <div className="CnPrivacy-footerNavItem">私隐政策</div>
            </Link>

            <Link to="/CnTerms">
              <div className="CnPrivacy-footerNavItem">使用条款</div>
            </Link>
          </div>

          <div className="CnPrivacy-footer_text">
            香港九龙油塘四山街 11 号
            <br />
            华利工业大厦5楼A室
            <br />
            <p />
            Copyright © 2026 CheckPlus Ltd. 保留一切权利。
          </div>
        </div>
      </div>
    );
  }
}

export default CnPrivacy;
